/**
 * [MC] PDP Gamified Bundle Builder — Variation 2 (title-top tiles, full-width Add)
 *
 * Adds a gamified Build-A-Pack layer to the single-sock PDP:
 *   • a tier slider ("Build your pack:") with 2 / 4 / 6+ stops that fills,
 *     flips SAVE badges navy + checks stops as pairs are added;
 *   • a yellow offer pill in the Choose-styles header ("Add N more pair(s)…");
 *   • a quick-add "+" (→ [− n +] stepper) on every style tile;
 *   • a re-rendered sticky ATC: "Add n Pairs To Cart  $TOTAL  $struck".
 *
 * The tiered discount is theme-native (auto-applied at checkout) — this layer
 * only tracks + displays pack state and adds the chosen variants to cart.
 *
 * Loaded on OS3 socks and pattern PDPs, gated behind the section setting
 * `enable_bundle_builder` (see sections/product-template-os3base.liquid) - on for
 * os3base (socks) and os3pattern (women's printed scrub tops, window.mcBBPattern:
 * 2 / 3+ tops = 10 / 15% off, sizes from the .varin radios).
 *
 * Selectors (live recon): styles grid `.scrubs-products` › `.flexerd` ›
 * `.style-option[data-id][data-price]`; Type row `.selected-type-text`
 * (in `.option-label`); sticky ATC `.add-to-cart-btn`.
 */
(function () {
  'use strict';

  var MARKER = 'mc-bb-injected';
  // cents, per pair - the selected variant's price in the shopper's currency (AU $34.90 if missing)
  var PRICE_FALLBACK = (window.os3CurrentVariant && window.os3CurrentVariant.price) || 3490;

  // ── Poller ─────────────────────────────────────────────────────────────────
  var pollerLite = function (conds, cb, maxTime) {
    maxTime = maxTime || 12000;
    var start = Date.now();
    var iv = setInterval(function () {
      var ok = conds.every(function (c) { return typeof c === 'function' ? c() : !!document.querySelector(c); });
      if (ok) { clearInterval(iv); cb(); }
      else if (Date.now() - start >= maxTime) { clearInterval(iv); console.error('[mc-bb] poll timeout'); }
    }, 25);
  };

  // ── Icons ────────────────────────────────────────────────────────────────
  var ICON_PLUS = '<svg viewBox="0 0 13 13" aria-hidden="true"><circle cx="6.5" cy="6.5" r="6.5" fill="#0B0D32"/><path d="M6.5 3.4V9.6M3.4 6.5H9.6" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>'; // in-progress (Figma 177:14)
  var ICON_DONE = '<svg viewBox="0 0 13 13" aria-hidden="true"><circle cx="6.5" cy="6.5" r="6.5" fill="#0B0D32"/><path d="M3.2 6.8L5.4 9L9.8 4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'; // unlocked (Figma 177:34)
  var ICON_CHECK = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 6.2 5 8.5 9.5 3.5" fill="none" stroke="#f5be16" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // ── Tier math ────────────────────────────────────────────────────────────
  var STOPS = [
    { pairs: 2, save: 'SAVE 10%', pos: 13, cls: 'mc-bb-stop--first' },
    { pairs: 4, save: 'SAVE 25%', pos: 50, cls: '' },
    { pairs: 6, save: 'SAVE 30% + <span class="mc-bb-ship-full">FREE SHIPPING</span><span class="mc-bb-ship-short">FREE SHIP</span>', pos: 87, cls: 'mc-bb-stop--last' }
  ];
  var tierPct = function (p) { return p >= 6 ? 0.30 : p >= 4 ? 0.25 : p >= 2 ? 0.10 : 0; };

  // [MC] Printed scrub tops (OS3 pattern pages - window.mcBBPattern, set by
  // snippets/product-template-os3base.liquid on os3pattern): the printed scrubs offer,
  // 2 tops 10% off and 3+ tops 15% off, counted like the cart bar's "Printed Scrub Tops
  // Offer" (Printed Pattern Scrub Tops, no Disney). Sizes come from the .varin radios
  // (+ Inseam where there is one) instead of the socks Type / Size buttons.
  var PATTERN = !!window.mcBBPattern;
  var UNIT = PATTERN ? 'top' : 'pair';
  if (PATTERN) {
    STOPS = [
      { pairs: 2, save: 'SAVE 10%', pos: 50, cls: 'mc-bb-stop--first' },
      { pairs: 3, save: 'SAVE 15%', pos: 87, cls: 'mc-bb-stop--last' }
    ];
    tierPct = function (p) { return p >= 3 ? 0.15 : p >= 2 ? 0.10 : 0; };
  }
  // Pattern variants are keyed productId-size-inseam (getCurrentVariantInfo's pattern branch).
  var patternVariant = function (id) {
    var pv = window.productVariants || {};
    var sizeEl = document.querySelector('.varin[name="Size"]:checked') || document.querySelector('.varin:checked');
    var inseamEl = document.querySelector('.varin[name="Inseam"]:checked');
    var size = sizeEl ? (sizeEl.getAttribute('op_val') || '') : '';
    var inseam = inseamEl ? (inseamEl.getAttribute('op_val') || '') : '';
    return pv[id + '-' + size.toLowerCase() + '-' + inseam.toLowerCase()] || null;
  };

  // [MC] Buy 3 Get 3 Free + free shipping (theme settings "Buy 3 Get 3 (US + Intl)", off by
  // default). window.mcB3G3 is set by snippets/product-template-os3base.liquid only while the
  // switch is on for this shopper: { badge, here, ids: { productId: 1 } }. The 10/25/30% ladder
  // is gone for that market then: on a product in the offer (here) the bar shows the B3G3F
  // stops - 3 pairs (buy 3) and 6 pairs (3 free + free shipping) - counting only the
  // collection's pairs, like the discount; elsewhere there is no pack bar. The ATC shows full
  // price either way (no tier discount any more).
  var B3G3_BUY = 3, B3G3_GET = 3;
  var B3_STOPS = [
    { pairs: 3, save: 'BUY 3', pos: 45, cls: 'mc-bb-stop--first' },
    { pairs: 6, save: '3 FREE + <span class="mc-bb-ship-full">FREE SHIPPING</span><span class="mc-bb-ship-short">FREE SHIP</span>', pos: 87, cls: 'mc-bb-stop--last' }
  ];
  var posForB3 = function (p) {
    if (p <= 0) return 0;
    if (p <= 3) return (p / 3) * 45;
    if (p < 6) return 45 + ((p - 3) / 3) * 42;
    return 100; // 6+ pairs: fill the whole bar, like the ladder
  };
  var b3g3 = function () { var b = window.mcB3G3; return (b && b.ids) ? b : null; };
  var posForPairs = function (p) {
    if (p <= 0) return 0;
    if (PATTERN) {
      if (p <= 2) return (p / 2) * 50;
      if (p < 3) return 50 + (p - 2) * 37;
      return 100; // 3+ tops: fill the whole bar
    }
    if (p <= 2) return (p / 2) * 13;
    if (p <= 4) return 13 + ((p - 2) / 2) * 37;
    if (p < 6) return 50 + ((p - 4) / 2) * 37;
    return 100; // 6+ pairs: fill the whole bar; knob moves off the 6-stop so its checkmark shows
  };

  // ── Pack state ─────────────────────────────────────────────────────────────
  // key = tile data-id, value = { qty, name, price(cents), tile }
  var pack = {};
  var totalPairs = function () { var n = 0; for (var k in pack) n += pack[k].qty; return n; };

  // The tile the ATC represents when the shopper hasn't picked any pairs: the
  // actively selected style, else the CURRENT product's tile (the page you're on),
  // else a stand-in for the current product, else the first tile.
  // Without the current-product fallback, landing on a non-first colour added the first
  // tile (Black Bamboo) instead of the shown product.
  var currentProductHandle = function () {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  };
  var currentProductId = function () {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return (meta && meta.product && meta.product.id) ? String(meta.product.id) : '';
  };
  // [MC] A design pulled from the designs collection (clearance, discontinued)
  // keeps a live PDP but renders NO tile in the Choose-styles grid, because the
  // grid is collections[collection_designs].products. The old last resort here
  // was `document.querySelector('.style-option')` - the FIRST tile, a DIFFERENT
  // PRODUCT - so e.g. the Hit for Six PDP priced, gated AND ADDED Black Bamboo.
  // Stand in a detached tile for the current product instead. It only has to
  // carry data-id/data-handle: window.productVariants is keyed by product id and
  // already holds this product's variants even with no tile, so all three
  // consumers (shownSingleState, shownVariantCents, addToCart's resolve) read the
  // right product. Substituting a different product is never correct here.
  var soloTile = null;
  var currentProductTile = function () {
    var id = currentProductId();
    var handle = currentProductHandle();
    if (!id || !handle) return null;
    if (soloTile && soloTile.getAttribute('data-id') === id) return soloTile;
    var og = document.querySelector('meta[property="og:title"]');
    soloTile = document.createElement('div');
    soloTile.setAttribute('data-id', id);
    soloTile.setAttribute('data-handle', handle);
    soloTile.setAttribute('data-title', (og && og.content) || document.title);
    return soloTile;
  };
  var shownTile = function () {
    var h = currentProductHandle();
    return document.querySelector('.style-option.active')
      || (h && document.querySelector('.style-option[data-handle="' + h + '"]'))
      || currentProductTile()
      || document.querySelector('.style-option');
  };
  // Pairs of compression socks ALREADY in the cart. The theme's Boost volume
  // discount applies to the whole cart, so the tiers must count these too.
  var cartPairs = 0;
  var b3g3CartPairs = 0; // [MC] cart pairs from the B3G3 collection (one-time purchases)
  var cartListenerAdded = false;
  var refreshCartPairs = function (cb) {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0;
        var B3 = b3g3(), b3n = 0;
        (cart && cart.items || []).forEach(function (it) {
          if (B3 && B3.ids[it.product_id] && !it.selling_plan_allocation) b3n += it.quantity;
        });
        b3g3CartPairs = b3n;
        (cart && cart.items || []).forEach(function (it) {
          if (PATTERN) {
            // [MC] the cart bar's printed scrub tops count (snippets/cart-drawer-progress.liquid)
            if (it.product_type === 'Printed Pattern Scrub Tops' && !/disney/i.test(it.title || '')) n += it.quantity;
            return;
          }
          if (!/compression sock/i.test(it.product_type || '')) return;
          // [MC] Disney + clearance socks are excluded from the tiered pack
          // discount, so they must NOT count toward the progress bar — mirrors
          // snippets/cart-drawer-progress.liquid (name-based Disney; clearance
          // via product type or the isClearance line-item property).
          var isDisney = /disney/i.test(it.title || '');
          var isClear = /clearance/i.test(it.product_type || '')
            || (it.properties && (it.properties.isClearance === 'true' || it.properties['Is Clearance'] === 'true'));
          if (isDisney || isClear) return;
          n += it.quantity;
        });
        cartPairs = n;
      })
      .catch(function () {})
      .then(function () { if (cb) cb(); });
  };
  var rawCents = function () { var c = 0; for (var k in pack) c += pack[k].qty * pack[k].price; return c; };
  // [MC] In the shopper's currency - window.mcMoney (sections/product-template-os3base.liquid)
  // follows the store's money format, so "QAR 99,00" / "449.000₫" / "Rs. 2,400.00" read right.
  var fmt = function (cents) { return window.mcMoney ? window.mcMoney.format(cents) : '$' + (cents / 100).toFixed(2); };
  var parsePrice = function (s) {
    var c = window.mcMoney ? window.mcMoney.parse(s) : Math.round((parseFloat(String(s || '').replace(/[^0-9.]/g, '')) || 0) * 100);
    return c || PRICE_FALLBACK;
  };

  // ── Build: slider block ──────────────────────────────────────────────────
  var stopsHtml = function (list) {
    return list.map(function (s) {
      return '<div class="mc-bb-stop ' + s.cls + '" data-pairs="' + s.pairs + '" style="--mc-bb-pos:' + s.pos + '%">'
        + '<span class="mc-bb-stop__badge">' + s.save + '</span>'
        + '<span class="mc-bb-stop__label">' + s.pairs + (s.cls.indexOf('last') > -1 ? '+ ' : ' ') + UNIT + 's</span>'
        + '<span class="mc-bb-stop__dot"><span class="mc-bb-stop__check">' + ICON_CHECK + '</span></span>'
        + '</div>';
    }).join('');
  };
  var buildSlider = function () {
    var sec = document.createElement('section');
    sec.className = 'mc-bb-slider ' + MARKER;
    sec.setAttribute('data-mc-bb-mode', 'tiers');
    sec.innerHTML =
      '<p class="mc-bb-slider__label">Build your pack:</p>'
      + '<div class="mc-bb-slider__panel"><div class="mc-bb-slider__rail">'
      + '<div class="mc-bb-slider__track"></div>'
      + '<div class="mc-bb-slider__fill"></div>'
      + stopsHtml(STOPS)
      + '<div class="mc-bb-slider__knob"></div>'
      + '</div></div>'
      // [MC] Printed tops: Disney designs don't count toward the offer (or get its discount).
      + (PATTERN ? '<p class="mc-bb-slider__note">*Disney Products are not discount eligible</p>' : '');
    return sec;
  };
  // [MC] Swap the stops between the ladder ('tiers') and B3G3F ('b3g3') when the mode
  // changes - checked on every render, so it follows window.mcB3G3 even if the slider is rebuilt.
  var syncStops = function (slider, mode) {
    if (slider.getAttribute('data-mc-bb-mode') === mode) return;
    var rail = slider.querySelector('.mc-bb-slider__rail');
    if (!rail) return;
    Array.prototype.forEach.call(rail.querySelectorAll('.mc-bb-stop'), function (st) { st.parentNode.removeChild(st); });
    var tmp = document.createElement('div');
    tmp.innerHTML = stopsHtml(mode === 'b3g3' ? B3_STOPS : STOPS);
    var knob = rail.querySelector('.mc-bb-slider__knob');
    while (tmp.firstChild) rail.insertBefore(tmp.firstChild, knob);
    slider.setAttribute('data-mc-bb-mode', mode);
  };

  // ── Build: offer pill ──────────────────────────────────────────────────────
  var buildOffer = function () {
    var el = document.createElement('div');
    el.className = 'mc-bb-offer ' + MARKER;
    el.innerHTML = '<span class="mc-bb-offer__icon">' + ICON_PLUS + '</span><span class="mc-bb-offer__text"></span>';
    return el;
  };

  // ── Decorate one style tile with quick-add / stepper ───────────────────────
  var decorateTile = function (styleOption) {
    if (!styleOption) return;
    var host = styleOption.closest('.flexerd') || styleOption;
    if (host.querySelector('.mc-bb-add') || host.querySelector('.mc-bb-stepper')) return;
    styleOption.classList.add('mc-bb-tile'); host.classList.add('mc-bb-tile--full');
    markTrunc(styleOption); // stash full name + flag if the 1-line name overflows (→ hover tooltip)
    var id = styleOption.getAttribute('data-id') || '';
    var name = styleOption.getAttribute('data-title') || '';
    var price = parsePrice(styleOption.getAttribute('data-price'));
    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'mc-bb-add mc-bb-add--full';
    add.setAttribute('aria-label', 'Add ' + (name || 'this style') + ' to pack');
    add.textContent = 'Add';
    add.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (!isTileAvailable(id)) return; // out of stock at the selected Type / Size
      pack[id] = pack[id] || { qty: 0, name: name, price: price, tile: styleOption };
      pack[id].qty += 1;
      renderTile(styleOption);
      renderAll();
    });
    host.appendChild(add);
  };

  // Swap between "+" and stepper for a tile based on its qty.
  var renderTile = function (styleOption) {
    var id = styleOption.getAttribute('data-id') || '';
    var qty = pack[id] ? pack[id].qty : 0;
    var host = styleOption.closest('.flexerd') || styleOption;
    var add = host.querySelector('.mc-bb-add');
    var stepper = host.querySelector('.mc-bb-stepper');
    if (qty > 0) {
      if (add) add.style.display = 'none';
      if (!stepper) {
        stepper = document.createElement('div');
        stepper.className = 'mc-bb-stepper mc-bb-stepper--full';
        stepper.innerHTML = '<button type="button" class="mc-bb-stepper__btn mc-bb-stepper__minus" aria-label="Decrease">−</button>'
          + '<span class="mc-bb-stepper__qty">' + qty + '</span>'
          + '<button type="button" class="mc-bb-stepper__btn mc-bb-stepper__plus" aria-label="Increase">+</button>';
        stepper.querySelector('.mc-bb-stepper__minus').addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          pack[id].qty -= 1;
          if (pack[id].qty <= 0) delete pack[id];
          renderTile(styleOption); renderAll();
        });
        stepper.querySelector('.mc-bb-stepper__plus').addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (!isTileAvailable(id)) return; // sold out in the selected size: "−" only
          pack[id].qty += 1;
          renderTile(styleOption); renderAll();
        });
        host.appendChild(stepper);
      } else {
        stepper.querySelector('.mc-bb-stepper__qty').textContent = qty;
      }
    } else {
      if (stepper) stepper.remove();
      if (add) add.style.display = '';
    }
  };

  // ── Render: slider + offer + ATC off current state ─────────────────────────
  // Out-of-stock gate: use the theme's own window.productVariants map +
  // buildVariantKey (see product-template-os3base.liquid) to check whether each
  // tile's variant can take pairs at the selected Type + Size. Fails open if the
  // map isn't present. [MC] `available` alone isn't enough: Shopify keeps selling
  // an out-of-stock variant whose "Continue selling when out of stock" is ticked,
  // and only the pre-order metaobject says where that's a pre-order. So a tile
  // takes pairs when it's in stock or on pre-order in this region - the empty-pack
  // ATC's rule (shownSingleState), which shows Notify Me for the rest. Its Add
  // used to take them anyway (e.g. Nude 1 Wide / M in PH, sold out, no pre-order).
  var isTileAvailable = function (id) {
    var pv = window.productVariants;
    if (!pv) return true;
    var v = null;
    if (PATTERN) v = patternVariant(id);
    else {
      var type = (document.querySelector('.selected-type') || {}).value || 'Regular';
      var size = (document.querySelector('.selected-size') || {}).value || 'S';
      if (typeof window.buildVariantKey === 'function') v = pv[window.buildVariantKey(id, type, size)];
      if (!v) { var t = String(type).toLowerCase(), s = String(size).toLowerCase(); v = pv[id + '-' + t + '-' + s] || pv[id + '-' + s]; }
    }
    if (!(v && v.available)) return false;
    if (!(v.inventory <= 0)) return true; // in stock (or no stock figure)
    var effect = (window.preOrderOverrides && window.preOrderOverrides.getVariantEffect)
      ? window.preOrderOverrides.getVariantEffect(v.id, v.inventory) : null;
    return effect === 'date';
  };
  var renderAvailability = function () {
    [].slice.call(document.querySelectorAll('.scrubs-products .flexerd .style-option')).forEach(function (so) {
      var host = so.closest('.flexerd') || so;
      host.classList.toggle('mc-bb-oos', !isTileAvailable(so.getAttribute('data-id')));
    });
  };

  // Resolve the shown single's ATC state the same way the theme's
  // updateCurrentProductStatus does — honouring inventory AND the pre-order
  // metaobject (window.preOrderOverrides) — so the empty-pack ATC can show
  // Add To Cart / Pre-Order / Notify Me / Sold Out instead of collapsing
  // everything to Add To Cart / Sold Out off `available` alone.
  var shownSingleState = function (tile) {
    if (!tile) return 'pick';
    var id = tile.getAttribute('data-id');
    var type = (document.querySelector('.selected-type') || {}).value || 'Regular';
    var size = (document.querySelector('.selected-size') || {}).value || 'S';
    var pv = window.productVariants || {};
    var v = null;
    if (PATTERN) v = patternVariant(id);
    else if (typeof window.buildVariantKey === 'function') v = pv[window.buildVariantKey(id, type, size)];
    if (!v && !PATTERN) { var t = String(type).toLowerCase(), s = String(size).toLowerCase(); v = pv[id + '-' + t + '-' + s] || pv[id + '-' + s]; }
    if (!v) return 'soldout';
    if (v.available && v.inventory > 0) return 'add';
    if (v.available && v.inventory <= 0) {
      var effect = (window.preOrderOverrides && window.preOrderOverrides.getVariantEffect)
        ? window.preOrderOverrides.getVariantEffect(v.id, v.inventory) : null;
      if (effect === 'date') return 'preorder';
      if (effect === false) return 'soldout';
      return 'notify';   // effect notify/null
    }
    return 'notify';     // !available
  };
  // Price (cents) of the shown tile's variant at the selected Type/Size, so the
  // ATC reflects the selected variant (e.g. Extra Wide = $25 on the US market)
  // instead of the tile's default/regular data-price. Falls back to data-price.
  var shownVariantCents = function (tile) {
    var fallback = tile ? parsePrice(tile.getAttribute('data-price')) : PRICE_FALLBACK;
    var pv = window.productVariants;
    if (!pv || !tile) return fallback;
    var id = tile.getAttribute('data-id');
    var type = (document.querySelector('.selected-type') || {}).value || 'Regular';
    var size = (document.querySelector('.selected-size') || {}).value || 'S';
    var v = null;
    if (PATTERN) v = patternVariant(id);
    else if (typeof window.buildVariantKey === 'function') v = pv[window.buildVariantKey(id, type, size)];
    if (!v && !PATTERN) { var t = String(type).toLowerCase(), s = String(size).toLowerCase(); v = pv[id + '-' + t + '-' + s] || pv[id + '-' + s]; }
    if (v && v.price) { var c = parsePrice(v.price); if (c) return c; }
    return fallback;
  };
  // Hand the ATC over to (or back from) the theme's notify flow, which hides
  // .add-to-cart-section and shows the "Notify Me When Back in Stock" button.
  var setNotify = function (on) {
    if (on) { if (typeof showNotifyForm === 'function') showNotifyForm(); }
    else if (typeof hideNotifyForm === 'function') hideNotifyForm();
  };

  var renderAll = function () {
    renderAvailability();
    var built = totalPairs();          // pairs the shopper is adding right now (drives the ATC label/price)
    // [MC] Disney / clearance socks are excluded from the tiered pack discount, so
    // they must NOT advance the progress bar. Zero everything on a Disney/clearance
    // PDP (window.mcPackExclude — also covers clearance designs, which we can't
    // detect per tile); otherwise skip individual Disney design tiles picked from
    // the grid (by data-title or the flexerd's data-tag). Keep `built` (the real
    // count) for the ATC label.
    var countable = 0;
    var countableCents = 0; // [MC] printed scrubs: the ATC discounts only these (Disney tops pay full price)
    if (!window.mcPackExclude) {
      for (var _k in pack) {
        var _p = pack[_k];
        var _fx = (_p.tile && _p.tile.closest) ? _p.tile.closest('.flexerd') : null;
        var _isDisney = /disney/i.test(_p.name || '')
          || (_fx && /disney/i.test(_fx.getAttribute('data-tag') || ''));
        if (!_isDisney) { countable += _p.qty; countableCents += _p.qty * _p.price; }
      }
    }
    var pairs = cartPairs + countable; // + eligible socks already in the cart → drives the tiers
    // [MC] Buy 3 Get 3 Free + free shipping (switch on for this shopper): only pairs from the
    // discount's collection count (pack tiles are keyed by product id, like the ids). No ladder
    // then - no tier discount on the ATC; the bar is B3G3F on products in the offer, none elsewhere.
    var B3 = b3g3();
    var b3Mode = !!(B3 && B3.here);
    var b3Off = !!(B3 && !B3.here);
    var pct = (window.mcPackExclude || B3) ? 0 : tierPct(pairs);
    var b3Pairs = 0;
    if (B3) {
      b3Pairs = b3g3CartPairs;
      for (var _b in pack) { if (B3.ids[_b]) b3Pairs += pack[_b].qty; }
    }
    var barPairs = b3Mode ? b3Pairs : pairs;

    // slider
    var slider = document.querySelector('.mc-bb-slider');
    if (slider) {
      slider.style.display = b3Off ? 'none' : '';
      syncStops(slider, b3Mode ? 'b3g3' : 'tiers');
      var fillPos = b3Mode ? posForB3(b3Pairs) : posForPairs(pairs);
      var fill = slider.querySelector('.mc-bb-slider__fill');
      var knob = slider.querySelector('.mc-bb-slider__knob');
      if (fill) fill.style.setProperty('--mc-bb-fill', fillPos + '%'), fill.style.width = fillPos + '%';
      if (knob) knob.style.setProperty('--mc-bb-knob', fillPos + '%'), knob.style.left = fillPos + '%';
      slider.querySelectorAll('.mc-bb-stop').forEach(function (st) {
        var need = parseInt(st.getAttribute('data-pairs'), 10);
        st.classList.toggle('mc-bb-stop--reached', barPairs >= need);
      });
    }

    // offer pill
    var offer = document.querySelector('.mc-bb-offer');
    if (offer) {
      offer.style.display = b3Off ? 'none' : '';
      var t = offer.querySelector('.mc-bb-offer__text');
      var ic = offer.querySelector('.mc-bb-offer__icon');
      offer.classList.remove('mc-bb-offer--unlocked');
      if (b3Mode) {
        // [MC] B3G3F: unlock at 3 pairs, 3 free + free shipping once 6 are in.
        var b3Total = B3G3_BUY + B3G3_GET;
        var b3Offer = B3.badge + ' + FREE SHIPPING';
        if (b3Pairs >= b3Total) {
          offer.classList.add('mc-bb-offer--unlocked');
          if (ic) ic.innerHTML = ICON_DONE;
          if (t) t.textContent = "You've unlocked " + b3Offer;
        } else {
          if (ic) ic.innerHTML = ICON_PLUS;
          var b3Need = (b3Pairs < B3G3_BUY ? B3G3_BUY : b3Total) - b3Pairs;
          if (t) t.textContent = 'Add ' + b3Need + (b3Pairs ? ' more' : '') + ' pair' + (b3Need === 1 ? '' : 's')
            + (b3Pairs < B3G3_BUY ? ' to unlock ' + b3Offer : ' to get ' + B3G3_GET + ' pairs FREE + FREE SHIPPING');
        }
      } else if (pairs >= STOPS[STOPS.length - 1].pairs) {
        offer.classList.add('mc-bb-offer--unlocked');
        if (ic) ic.innerHTML = ICON_DONE;   // circle + checkmark
        if (t) t.textContent = PATTERN ? "You've unlocked 15% OFF" : "You've unlocked 30% OFF + FREE SHIPPING";
      } else {
        if (ic) ic.innerHTML = ICON_PLUS;   // circle + plus
        var nextStop = STOPS.filter(function (s) { return pairs < s.pairs; })[0].pairs;
        var nextPct = Math.round(tierPct(nextStop) * 100);
        var need = nextStop - pairs;
        if (t) t.textContent = 'Add ' + need + ' more ' + UNIT + (need === 1 ? '' : 's') + ' to receive ' + nextPct + '% off';
      }
    }

    // ATC
    var atc = document.querySelector('.add-to-cart-btn');
    if (atc) {
      atc.classList.add('mc-bb-atc');
      // [MC] The theme writes to #addToCartText without a null check - socks'
      // updateCurrentProductStatus (through window.addToCartText) and printed scrubs'
      // updatePatternButtonState - and threw once our label replaced it: on socks that left
      // its re-entry guard set, freezing the button on a sold-out size's "disabled" while we
      // relabelled it Add To Cart. Our label keeps that id; we re-render after it (mcBBRender).
      var LABEL = '<span class="mc-bb-atc__label" id="addToCartText">';
      if (built < 1) {
        // No tiles picked → the ATC represents the currently-shown/active style
        // (1 pair). Mirror the theme's status states, incl. the pre-order
        // metaobject, instead of only Add To Cart / Sold Out.
        var shown0 = shownTile();
        var mode = shownSingleState(shown0);
        if (mode === 'notify') {
          // Not sellable + not pre-order → hand off to the theme's notify flow
          // (hides this ATC, shows "Notify Me When Back in Stock").
          setNotify(true);
        } else {
          setNotify(false);
          if (mode === 'add' || mode === 'preorder') {
            atc.classList.remove('mc-bb-atc--disabled');
            // [MC] The theme's sold-out state from an earlier selection mustn't outlive it.
            atc.disabled = false; atc.classList.remove('sold-out');
            var shownCents = shownVariantCents(shown0);
            atc.innerHTML = LABEL + (mode === 'preorder' ? 'Pre-Order' : 'Add To Cart') + '</span><span class="mc-bb-atc__pill">' + fmt(shownCents) + '</span>';
          } else {
            atc.classList.add('mc-bb-atc--disabled');
            atc.innerHTML = LABEL + (mode === 'pick' ? 'Pick Your ' + (PATTERN ? 'Tops' : 'Pairs') : 'Sold Out') + '</span>';
          }
        }
      } else {
        setNotify(false);
        // [MC] Styles picked before the shopper changed to a size they're sold out in: no add
        // until they're taken out (their "−" still works) or the size goes back - otherwise
        // /cart/add.js rejects the sold-out variant.
        var soldOut = 0;
        for (var _s in pack) { if (pack[_s].qty > 0 && !isTileAvailable(_s)) soldOut += 1; }
        if (soldOut) {
          atc.classList.add('mc-bb-atc--disabled');
          atc.innerHTML = LABEL + soldOut + ' Style' + (soldOut === 1 ? '' : 's') + ' Sold Out In This Size</span>';
        } else {
          atc.classList.remove('mc-bb-atc--disabled');
          // [MC] The theme disables the button when the PAGE's design is sold out in the chosen
          // size - the picked designs aren't, so they stay addable.
          atc.disabled = false; atc.classList.remove('sold-out');
          var raw = rawCents();
          var disc = PATTERN
            ? raw - Math.round(countableCents * pct)
            : Math.round(raw * (1 - pct)); // discount % reflects the effective tier (cart + pack)
          var pill = pct > 0
            ? '<span class="mc-bb-atc__pill">' + fmt(disc) + ' <span class="mc-bb-atc__was">' + fmt(raw) + '</span></span>'
            : '<span class="mc-bb-atc__pill">' + fmt(raw) + '</span>';
          atc.innerHTML = LABEL + 'Add ' + built + (PATTERN ? ' Top' : ' Pair') + (built === 1 ? '' : 's') + ' To Cart</span>' + pill;
        }
      }
    }
  };

  // Open the theme's AJAX cart drawer instead of a full redirect: refresh the
  // two live regions from /cart, then fire the drawer-open path + cart:open
  // (mirrors snippets/javascripts.liquid's post-AJAX-add flow).
  var openCartDrawer = function () {
    fetch('/cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var hmc = document.querySelector('.header-main-cart');
        var cdc = document.querySelector('.cart_drawer_custom');
        var nHmc = doc.querySelector('.header-main-cart');
        var nCdc = doc.querySelector('.cart_drawer_custom');
        if (hmc && nHmc) hmc.innerHTML = nHmc.innerHTML;
        if (cdc && nCdc) cdc.innerHTML = nCdc.innerHTML;
        document.querySelectorAll('a.open-cart-drawer-new').forEach(function (el) { el.click(); });
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function () {
        var o = document.querySelector('.js-drawer-open-cart, a.open-cart-drawer-new');
        if (o) o.click();
      });
  };

  // ── Add to cart (theme discount auto-applies at checkout) ──────────────────
  var addToCart = function () {
    var entries = [];
    for (var k in pack) { if (pack[k].qty > 0) entries.push(pack[k]); }
    // No tiles picked → add the currently-shown/active style, 1 pair. Once the
    // shopper has clicked "Add" on tiles, only those are added (entries above).
    if (!entries.length) {
      var shown = shownTile();
      if (shown) entries.push({ qty: 1, tile: shown, name: shown.getAttribute('data-title') || '', price: parsePrice(shown.getAttribute('data-price')) });
    }
    if (!entries.length) return;
    // The tile data-id is the PRODUCT id, not a purchasable variant. Resolve each
    // style's variant from the selected Type/Size (e.g. "Regular / S") via its
    // product JSON, then add them all. The theme's tiered discount auto-applies.
    var typeEl = document.querySelector('.selected-type');
    var sizeEl = document.querySelector('.selected-size');
    var type = typeEl ? (typeEl.value || '').trim() : '';
    var size = sizeEl ? (sizeEl.value || '').trim() : '';
    var want = type + ' / ' + size;
    var resolve = function (e) {
      // [MC] Printed scrubs: the variant is in productVariants under the picked Size (+ Inseam).
      if (PATTERN) {
        var pvar = e.tile ? patternVariant(e.tile.getAttribute('data-id')) : null;
        return Promise.resolve(pvar ? { id: pvar.id, quantity: e.qty } : null);
      }
      var handle = e.tile ? (e.tile.getAttribute('data-handle') || '') : '';
      if (!handle) return Promise.resolve(null);
      return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var vs = p.variants || [];
          var match = function (x) {
            return x.public_title === want
              || (x.options && x.options.join(' / ') === want)
              || (x.option1 === type && x.option2 === size);
          };
          var v = vs.filter(function (x) { return x.available !== false; }).find(match) || vs.find(match);
          return v ? { id: v.id, quantity: e.qty } : null;
        })
        .catch(function () { return null; });
    };
    Promise.all(entries.map(resolve)).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) { console.error('[mc-bb] no variants resolved for selection'); return; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) {
          // If a variant is short on stock, /cart/add.js 422s (and only the
          // available quantity is added, not the full amount). Alert with
          // Shopify's reason, then still refresh the drawer to reflect reality.
          if (!r.ok) {
            window.alert((data && (data.description || data.message)) ||
              'Sorry, some of your pack couldn\'t be added — a style just ran low on stock. Please adjust your selection.');
          } else {
            pack = {}; // added → reset the builder so the slider reflects the cart total (no double-count)
          }
          openCartDrawer(); // fires cart:open → re-counts cart socks + re-renders
        });
      }).catch(function () {
        window.alert('Sorry, something went wrong adding your pack. Please try again.');
      });
    });
  };

  // ── init ────────────────────────────────────────────────────────────────────
  var init = function () {
    if (document.querySelector('.mc-bb-slider')) { decorateAllTiles(); renderAll(); return; }

    // 1. slider above the whole Type section — anchor on `.option-section` (NOT
    // `.option-label`), so the Fit Guide, which is positioned to the section, stays
    // with the Type selector instead of jumping up beside the slider.
    var typeRow = (document.querySelector('.selected-type-text') || {}).closest ? document.querySelector('.selected-type-text').closest('.option-section') : null;
    // [MC] Printed scrubs: no Type row - the styles come first, so the slider sits above them.
    var stylesSection = PATTERN ? document.querySelector('.styles-section') : null;
    var slider = buildSlider();
    if (stylesSection && stylesSection.parentNode) {
      stylesSection.parentNode.insertBefore(slider, stylesSection);
    } else if (typeRow && typeRow.parentNode) {
      typeRow.parentNode.insertBefore(slider, typeRow);
    } else {
      var grid0 = document.querySelector('.scrubcaps-wrapper') || document.querySelector('.scrubs-products');
      if (grid0 && grid0.parentNode) grid0.parentNode.insertBefore(slider, grid0);
    }

    // 2. offer pill in the Choose-styles header (hide the theme's static text)
    var heading = [].slice.call(document.querySelectorAll('h2,h3,h4,.section-title,div,span,p'))
      .find(function (e) { return (e.textContent || '').trim().toLowerCase() === 'choose styles'; });
    var offer = buildOffer();
    if (heading && heading.parentNode) {
      heading.parentNode.insertBefore(offer, heading.nextSibling);
    } else {
      var wrap = document.querySelector('.scrubcaps-wrapper');
      if (wrap && wrap.parentNode) wrap.parentNode.insertBefore(offer, wrap);
    }

    // 3. quick-add / stepper on every tile
    decorateAllTiles();

    // 4. ATC → add pack to cart
    var atc = document.querySelector('.add-to-cart-btn');
    if (atc && !atc.dataset.mcBbWired) {
      atc.dataset.mcBbWired = '1';
      atc.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        // Empty pack adds the shown/active style; picked tiles add only those.
        // Only block when there's genuinely nothing to add (Sold Out state).
        if (atc.classList.contains('mc-bb-atc--disabled')) return;
        addToCart();
      }, true);
    }

    refreshCartPairs(renderAll); // reflect socks already in the cart on load

    if (!cartListenerAdded) {
      cartListenerAdded = true;
      document.addEventListener('cart:open', function () {
        refreshCartPairs(function () { decorateAllTiles(); renderAll(); });
      });
      // Poll the cart so progress also reflects REMOVALS (which don't reliably
      // fire cart:open); only re-render when the sock count actually changes.
      setInterval(function () {
        var prev = cartPairs, prevB3 = b3g3CartPairs; // [MC] B3G3 count can change on its own
        refreshCartPairs(function () { if (cartPairs !== prev || b3g3CartPairs !== prevB3) renderAll(); });
      }, 4000);
    }
  };

  // Flag tiles whose single-line (ellipsised) name overflows, and stash the
  // full text in data-mc-bb-name for the CSS tooltip. Long names then show a
  // floating popup on hover instead of expanding in place and pushing the
  // Add button out from under the cursor.
  var markTrunc = function (styleOption) {
    var host = styleOption.closest('.flexerd') || styleOption;
    var nm = host.querySelector('.style-name');
    if (!nm) return;
    host.setAttribute('data-mc-bb-name', (nm.textContent || '').trim());
    host.classList.toggle('mc-bb-name--trunc', nm.scrollWidth > nm.clientWidth + 1);
  };

  var decorateAllTiles = function () {
    [].slice.call(document.querySelectorAll('.scrubs-products .flexerd .style-option')).forEach(function (so) {
      decorateTile(so);
      renderTile(so);
      markTrunc(so); // re-check on every pass (widths can change with viewport / filter)
    });
  };

  // ── Entry ─────────────────────────────────────────────────────────────────
  pollerLite(['.scrubs-products .flexerd .style-option', '.add-to-cart-btn'], init);

  // [MC] The theme calls this at the end of every status update - printed scrubs'
  // updatePatternButtonState (its change handler and 600ms poll), socks'
  // updateCurrentProductStatus - so the builder's ATC / notify state is what's left, not the
  // theme's single-product "Add to Cart" / "Notify Me".
  window.mcBBRender = function () { if (document.querySelector('.mc-bb-slider')) renderAll(); };

  // Re-check availability when the shopper changes Type / Size (the theme updates
  // the hidden .selected-type / .selected-size inputs on .option-btn click).
  document.addEventListener('click', function (e) {
    // renderAll (not just renderAvailability) so the empty-state ATC price +
    // Sold Out state track the shown style's availability at the selected Type/Size.
    // Also re-run on style (design) select: the theme can fall the Type back
    // (e.g. Extra Wide -> Regular) when the newly-picked design lacks it, so the
    // tiles' OOS state must be recomputed for the resolved Type/Size. The
    // setTimeout defers past the theme's synchronous style-select handler, which
    // has already corrected .selected-type / .selected-size by the time we read.
    if (e.target && e.target.closest && (e.target.closest('.option-btn') || e.target.closest('.style-option'))) setTimeout(renderAll, 0);
  }, false);
  // [MC] Printed scrubs: sizes are .varin radios, so follow their change events too.
  document.addEventListener('change', function (e) {
    if (PATTERN && e.target && e.target.closest && e.target.closest('.varin')) setTimeout(renderAll, 0);
  }, false);

  // Re-evaluate name truncation on resize (column width changes flip which
  // names overflow → which get the hover tooltip).
  var _rzT;
  window.addEventListener('resize', function () {
    clearTimeout(_rzT);
    _rzT = setTimeout(function () {
      [].slice.call(document.querySelectorAll('.scrubs-products .flexerd .style-option')).forEach(markTrunc);
    }, 200);
  });

  // Re-render safe: theme rebuilds the styles grid (See-More etc.) — re-decorate
  // new tiles + re-inject the slider/offer if they vanish.
  var obs = new MutationObserver(function () {
    if (!document.querySelector('.mc-bb-slider') && document.querySelector('.scrubs-products .flexerd .style-option')) {
      init();
    } else if (document.querySelector('.scrubs-products .flexerd .style-option:not(.mc-bb-tile)')) {
      decorateAllTiles();
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
